"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnqInput = exports.triggerFocus = exports.resolveOnChange = exports.fixControlledValue = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var omit_1 = tslib_1.__importDefault(require("rc-util/lib/omit"));
var config_provider_1 = require("../config-provider");
var SizeContext_1 = tslib_1.__importDefault(require("../config-provider/SizeContext"));
var info_boundary_1 = tslib_1.__importDefault(require("../info-boundary"));
var byteLength_1 = require("../util/byteLength");
var ClearableLabeledInput_1 = tslib_1.__importDefault(require("./ClearableLabeledInput"));
var utils_1 = require("./utils");
function fixControlledValue(value) {
    if (typeof value === 'undefined' || value === null) {
        return '';
    }
    return value;
}
exports.fixControlledValue = fixControlledValue;
function resolveOnChange(target, e, onChange) {
    if (onChange) {
        var event_1 = e;
        if (e.type === 'click') {
            // click clear icon
            event_1 = Object.create(e);
            event_1.target = target;
            event_1.currentTarget = target;
            var originalInputValue = target.value;
            // change target ref value cause e.target.value should be '' when clear input
            target.value = '';
            onChange(event_1);
            // reset target ref value
            target.value = originalInputValue;
            return;
        }
        onChange(event_1);
    }
}
exports.resolveOnChange = resolveOnChange;
function triggerFocus(element, option) {
    if (!element) {
        return;
    }
    element.focus(option);
    // Selection content
    var cursor = (option || {}).cursor;
    if (cursor) {
        var len = element.value.length;
        switch (cursor) {
            case 'start':
                element.setSelectionRange(0, 0);
                break;
            case 'end':
                element.setSelectionRange(len, len);
                break;
            default:
                element.setSelectionRange(0, len);
        }
    }
}
exports.triggerFocus = triggerFocus;
var AnqInput = /** @class */ (function (_super) {
    tslib_1.__extends(AnqInput, _super);
    function AnqInput(props) {
        var _this = _super.call(this, props) || this;
        _this.direction = 'ltr';
        _this.focus = function (option) {
            triggerFocus(_this.input, option);
        };
        _this.saveClearableInput = function (input) {
            _this.clearableInput = input;
        };
        _this.saveInput = function (input) {
            _this.input = input;
        };
        _this.onFocus = function (e) {
            var onFocus = _this.props.onFocus;
            _this.setState({ focused: true }, _this.clearPasswordValueAttribute);
            if (onFocus) {
                onFocus(e);
            }
        };
        _this.onBlur = function (e) {
            var onBlur = _this.props.onBlur;
            _this.setState({ focused: false }, _this.clearPasswordValueAttribute);
            if (onBlur) {
                onBlur(e);
            }
        };
        _this.handleReset = function (e) {
            _this.setValue('', function () {
                _this.focus();
            });
            resolveOnChange(_this.input, e, _this.props.onChange);
        };
        _this.handleCompositionStart = function (e) {
            var _a, _b;
            (_b = (_a = _this.props).onCompositionStart) === null || _b === void 0 ? void 0 : _b.call(_a, e);
            if (_this.input) {
                _this.input.composing = true;
            }
        };
        _this.handleCompositionEnd = function (e) {
            var _a, _b;
            (_b = (_a = _this.props).onCompositionEnd) === null || _b === void 0 ? void 0 : _b.call(_a, e);
            if (_this.input) {
                _this.input.composing = false;
            }
            _this.handleChange(e);
        };
        _this.renderInput = function (prefixCls, size, bordered, input) {
            var _a;
            if (input === void 0) { input = {}; }
            var _b = _this.props, className = _b.className, addonBefore = _b.addonBefore, addonAfter = _b.addonAfter, customizeSize = _b.size, disabled = _b.disabled, isChineseAsTwoBytes = _b.isChineseAsTwoBytes;
            // Fix https://fb.me/react-unknown-prop
            var omitKeys = [
                'prefixCls',
                'onPressEnter',
                'addonBefore',
                'addonAfter',
                'prefix',
                'suffix',
                'allowClear',
                // Input elements must be either controlled or uncontrolled,
                // specify either the value prop, or the defaultValue prop, but not both.
                'defaultValue',
                'size',
                'inputType',
                'bordered',
                'showCount',
                'isChineseAsTwoBytes',
            ];
            if (isChineseAsTwoBytes) {
                omitKeys.push('maxLength');
            }
            var otherProps = (0, omit_1.default)(_this.props, omitKeys);
            return (React.createElement("input", tslib_1.__assign({ autoComplete: input.autoComplete }, otherProps, { onCompositionStart: _this.handleCompositionStart, onCompositionEnd: _this.handleCompositionEnd, onChange: _this.handleChange, onFocus: _this.onFocus, onBlur: _this.onBlur, onKeyDown: _this.handleKeyDown, className: (0, classnames_1.default)((0, utils_1.getInputClassName)(prefixCls, bordered, customizeSize || size, disabled, _this.direction), (_a = {},
                    _a[className] = className && !addonBefore && !addonAfter,
                    _a)), ref: _this.saveInput })));
        };
        _this.clearPasswordValueAttribute = function () {
            // https://github.com/ant-design/ant-design/issues/20541
            _this.removePasswordTimeout = setTimeout(function () {
                if (_this.input &&
                    _this.input.getAttribute('type') === 'password' &&
                    _this.input.hasAttribute('value')) {
                    _this.input.removeAttribute('value');
                }
            });
        };
        _this.handleChange = function (e) {
            var _a, _b;
            var _c = _this.props, isChineseAsTwoBytes = _c.isChineseAsTwoBytes, maxLength = _c.maxLength;
            var valStr = String(e.target.value || '');
            var valStrLength = isChineseAsTwoBytes ? (0, byteLength_1.byteLength)(valStr) : valStr.length;
            var overflowed = maxLength ? valStrLength > maxLength : false;
            if (!overflowed || ((_a = _this.input) === null || _a === void 0 ? void 0 : _a.composing)) {
                _this.setValue(e.target.value, _this.clearPasswordValueAttribute);
                resolveOnChange(_this.input, e, _this.props.onChange);
            }
            if (overflowed && !((_b = _this.input) === null || _b === void 0 ? void 0 : _b.composing)) {
                var cuted = (0, byteLength_1.cutString)(String(e.target.value), maxLength, isChineseAsTwoBytes);
                _this.setValue(cuted, _this.clearPasswordValueAttribute);
                e.target.value = cuted;
                resolveOnChange(_this.input, e, _this.props.onChange);
            }
        };
        _this.handleKeyDown = function (e) {
            var _a = _this.props, onPressEnter = _a.onPressEnter, onKeyDown = _a.onKeyDown;
            if (e.keyCode === 13 && onPressEnter) {
                onPressEnter(e);
            }
            if (onKeyDown) {
                onKeyDown(e);
            }
        };
        _this.renderComponent = function (_a) {
            var getPrefixCls = _a.getPrefixCls, direction = _a.direction, input = _a.input;
            var _b = _this.state, value = _b.value, focused = _b.focused;
            var _c = _this.props, customizePrefixCls = _c.prefixCls, _d = _c.bordered, bordered = _d === void 0 ? true : _d;
            var prefixCls = getPrefixCls('input', customizePrefixCls);
            _this.direction = direction;
            return (React.createElement(SizeContext_1.default.Consumer, null, function (size) { return (React.createElement(React.Fragment, null,
                React.createElement(ClearableLabeledInput_1.default, tslib_1.__assign({ size: size }, _this.props, { prefixCls: prefixCls, inputType: "input", value: fixControlledValue(value), element: _this.renderInput(prefixCls, size, bordered, input), handleReset: _this.handleReset, ref: _this.saveClearableInput, direction: direction, focused: focused, triggerFocus: _this.focus, bordered: bordered })))); }));
        };
        var value = typeof props.value === 'undefined' ? props.defaultValue : props.value;
        _this.state = {
            value: value,
            focused: false,
            prevValue: props.value,
        };
        return _this;
    }
    AnqInput.getDerivedStateFromProps = function (nextProps, _a) {
        var prevValue = _a.prevValue;
        var newState = { prevValue: nextProps.value };
        if (nextProps.value !== undefined || prevValue !== nextProps.value) {
            newState.value = nextProps.value;
        }
        return newState;
    };
    AnqInput.prototype.componentDidMount = function () {
        this.clearPasswordValueAttribute();
    };
    // Since polyfill `getSnapshotBeforeUpdate` need work with `componentDidUpdate`.
    // We keep an empty function here.
    AnqInput.prototype.componentDidUpdate = function () { };
    AnqInput.prototype.componentWillUnmount = function () {
        if (this.removePasswordTimeout) {
            clearTimeout(this.removePasswordTimeout);
        }
    };
    AnqInput.prototype.blur = function () {
        this.input.blur();
    };
    AnqInput.prototype.setSelectionRange = function (start, end, direction) {
        this.input.setSelectionRange(start, end, direction);
    };
    AnqInput.prototype.select = function () {
        this.input.select();
    };
    AnqInput.prototype.setValue = function (value, callback) {
        if (this.props.value === undefined) {
            this.setState({ value: value }, callback);
        }
        else {
            callback === null || callback === void 0 ? void 0 : callback();
        }
    };
    AnqInput.prototype.render = function () {
        return React.createElement(config_provider_1.ConfigConsumer, null, this.renderComponent);
    };
    AnqInput.defaultProps = {
        type: 'text',
        showCount: false,
        info: '',
    };
    return AnqInput;
}(React.Component));
exports.AnqInput = AnqInput;
var InputComponent = (0, info_boundary_1.default)(AnqInput);
exports.default = InputComponent;
//# sourceMappingURL=Input.js.map